import {helpers} from 'vuelidate/lib/validators'

// validator for EPP-style phone and fax numbers
export const phone = helpers.regex ('phone', /^\+[0-9]{1,3}\.[0-9]{1,14}$/)
